export default __webpack_public_path__ + "static/media/favorites-securedock.a326707b.png";